import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { NAV_KEYS, WHATSAPP_LINK, PHONE_RAW, PHONE_DISPLAY } from "../data/constants";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#070707] border-t border-[#1c1c1c]" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-20 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex flex-col leading-none">
              <span className="font-serif text-2xl tracking-[0.18em] text-[#FFFFF0]">PHANTOM</span>
              <span className="text-[0.65rem] tracking-[0.42em] text-[#D4AF37] mt-1">RESIDENCE</span>
            </div>
            <p className="mt-5 text-sm text-[#FFFFF0]/55 font-light italic font-serif text-lg">{t.footer.tagline}</p>
            <p className="mt-4 text-xs text-[#FFFFF0]/35 font-light leading-relaxed max-w-xs">{t.footer.disclaimer}</p>
          </div>

          <div>
            <p className="overline">{t.footer.menu}</p>
            <ul className="mt-5 grid grid-cols-2 gap-y-2.5">
              {NAV_KEYS.map((key) => (
                <li key={key}>
                  <button onClick={() => go(key)} className="text-sm text-[#FFFFF0]/60 hover:text-[#D4AF37] transition-colors font-light" data-testid={`footer-nav-${key}`}>
                    {t.nav[key]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="overline">{t.footer.contact}</p>
            <div className="mt-5 space-y-3">
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-[#FFFFF0]/60 hover:text-[#D4AF37] transition-colors" data-testid="footer-whatsapp">
                <MessageCircle size={16} strokeWidth={1.4} className="text-[#D4AF37]" /> WhatsApp · {PHONE_DISPLAY}
              </a>
              <a href={`tel:${PHONE_RAW}`} className="flex items-center gap-3 text-sm text-[#FFFFF0]/60 hover:text-[#D4AF37] transition-colors" data-testid="footer-phone">
                <Phone size={16} strokeWidth={1.4} className="text-[#D4AF37]" /> {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#1c1c1c] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#FFFFF0]/35">© {year} Phantom Residence. {t.footer.rights}</p>
          <p className="text-xs text-[#FFFFF0]/25">phantomresidence.com</p>
        </div>
      </div>
    </footer>
  );
};
